export * from './simple-layout.component';



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/containers/simple-layout/index.ts